import { useCallback, useEffect, useState } from "react";
import useAutoRetry from "../hooks/useAutoRetry";
import repository from "./repository";
import { RETRYABLE, problemOf } from "./problems";
import { recordFailure } from "./syncDiagnostics";

// status: "checking" | "ready" | "problem"
// Finds every approved, active learner activity attached to the current block.
const useLearnerActivity = (lessonId, blockId) => {
  const [state, setState] = useState({
    status: "checking",
    activities: [],
    problem: null,
  });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (!lessonId || !blockId) return undefined;
    let active = true;
    repository.listLearnerActivities({ lessonId, blockId }).then(
      (activities) => {
        if (active) setState({ status: "ready", activities, problem: null });
      },
      (error) => {
        if (!active) return;
        recordFailure(`activity:${lessonId}:${blockId}`, error);
        setState({
          status: "problem",
          activities: [],
          problem: problemOf(error),
        });
      }
    );
    return () => {
      active = false;
    };
  }, [lessonId, blockId, attempt]);

  const retry = useCallback(() => setAttempt((n) => n + 1), []);
  useAutoRetry(
    state.status === "problem" && RETRYABLE.has(state.problem),
    retry
  );

  return { ...state, retry };
};

export default useLearnerActivity;
